"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Story = _interopRequireDefault(require("../../Story"));

var _client = _interopRequireDefault(require("../client"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Story generated by the Stories-API endpoint.
*/
var StoriesAPIStory =
/*#__PURE__*/
function (_Component) {
  _inherits(StoriesAPIStory, _Component);

  function StoriesAPIStory(props) {
    var _this;

    _classCallCheck(this, StoriesAPIStory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StoriesAPIStory).call(this, props));
    var apiKey = props.apiKey,
        data = props.data,
        endpoint = props.endpoint;
    _this.state = {
      loading: data ? false : true,
      data: data,
      error: false
    };
    _this.client = new _client.default(endpoint, apiKey);
    _this.setError = _this.setError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StoriesAPIStory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.state.data) {
        this.setState({
          loading: true
        });
        this.fetchData(function (data) {
          _this2.setState({
            loading: false
          });
        });
      }
    }
  }, {
    key: "setError",
    value: function setError() {
      this.setState({
        error: true
      });
    }
  }, {
    key: "fetchData",
    value: function fetchData(callback) {
      var _this3 = this;

      var _this$props = this.props,
          collection = _this$props.collection,
          endpoint = _this$props.endpoint,
          id = _this$props.id,
          onLoad = _this$props.onLoad;
      return this.client.story(id, collection, null, null, function (story) {
        _this3.setState({
          data: story
        });

        onLoad && onLoad(story);
        return callback(story);
      }, this.setError);
    }
  }, {
    key: "renderMoments",
    value: function renderMoments() {
      var data = this.state.data;
      var storyMoments = [];
      data.moments.map(function (moment) {
        var type = moment.type;

        if (_utils.MomentUtils.isPublicMoment(moment)) {
          var index = storyMoments.length;
          storyMoments.push(_utils.MomentUtils.buildMoment(moment, index));
        }
      });
      return storyMoments;
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var loading = this.state.loading;
      return loading && _react.default.createElement(_core.Container, {
        style: {
          textAlign: "center"
        }
      }, _react.default.createElement(_core.Typography, {
        variant: "h5",
        color: "primary"
      }, "Building Your Story ..."), _react.default.createElement(_core.LinearProgress, {
        color: "secondary"
      }));
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var errorComponent = this.props.errorComponent;
      return errorComponent || _react.default.createElement(_core.Typography, null, "Something went wrong while loading this collection... ", _react.default.createElement("br", null), "Try Refreshing or Check Back Soon");
    }
  }, {
    key: "render",
    value: function render() {
      var options = this.props.options;
      var _this$state = this.state,
          error = _this$state.error,
          data = _this$state.data,
          loading = _this$state.loading;
      return error ? this.renderError() : this.renderLoading() || _react.default.createElement(_Story.default, _extends({}, data, options), this.renderMoments());
    }
  }]);

  return StoriesAPIStory;
}(_react.Component);

exports.default = StoriesAPIStory;

_defineProperty(StoriesAPIStory, "propTypes", {
  /** API Key to interact with the StoriesAPI */
  apiKey: _propTypes.default.string.isRequired,

  /** StoriesAPI collection id */
  collection: _propTypes.default.number,

  /** Override `StoriesAPI` data fetching to use custom data */
  data: _propTypes.default.object,

  /** `StoriesAPI` endpoint URL */
  endpoint: _propTypes.default.string.isRequired,

  /** Identifier of the `Story` */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,

  /** Props to pass to the `Story` component */
  options: _propTypes.default.object
});

_defineProperty(StoriesAPIStory, "defaultProps", {
  collection: null,
  data: null,
  endpoint: process.env.STORIES_API_URL,
  options: {}
});